import { IModalScope } from "angular-ui-bootstrap";
import { StateService } from "@uirouter/angularjs";
import { IChecklist } from "@gtmhub/onboarding";
import { OnboardingService } from "../onboarding.service";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { UserInvitationModalService } from "@gtmhub/users/components/user-invitation-form/user-invitation-modal.service";

export interface IOnboardingChecklistModalCtrlScope extends IModalScope {
  checklist: IChecklist;
  progress: number;
  availableActions: number;
  isAdmin: boolean;
  hasPermissionsToAccessPlanUpdate: boolean;
  inviteTeammate(): void;
  openVideo(): void;
  createOkr(): void;
  activateYourSubscription(): void;
  createDemoAccount(): void;
  skipCompletely(): void;
  openInvitationModal(): void;
}

export class OnboardingChecklistModalCtrl {
  public static $inject = [
    "$scope",
    "$state",
    "OnboardingService",
    "UIErrorHandlingService",
    "UserInvitationModalService",
    "checklist",
    "progress",
    "availableActions",
    "isAdmin",
    "hasPermissionsToAccessPlanUpdate",
  ];
  constructor(
    private $scope: IOnboardingChecklistModalCtrlScope,
    private $state: StateService,
    private onboardingService: OnboardingService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private userInvitationModal: UserInvitationModalService,
    private checklist: IChecklist,
    private progress: number,
    private availableActions: number,
    private isAdmin: boolean,
    private hasPermissionsToAccessPlanUpdate: boolean
  ) {
    this.$scope.checklist = this.checklist;
    this.$scope.progress = this.progress;
    this.$scope.availableActions = this.availableActions;
    this.$scope.isAdmin = this.isAdmin;
    this.$scope.hasPermissionsToAccessPlanUpdate = this.hasPermissionsToAccessPlanUpdate;
    this.$scope.inviteTeammate = this.inviteTeammate;
    this.$scope.openVideo = this.openVideo;
    this.$scope.createOkr = this.createOkr;
    this.$scope.activateYourSubscription = this.activateYourSubscription;
    this.$scope.createDemoAccount = this.createDemoAccount;
    this.$scope.skipCompletely = this.skipCompletely;
    this.$scope.openInvitationModal = this.openInvitationModal;
  }

  private inviteTeammate = () => {
    this.$scope.$close();
    this.$state.go("gtmhub.home._invitation.invite");
  };

  private openVideo = () => {
    this.$scope.checklist = this.onboardingService.openVideoModal(this.$scope.checklist);
    this.$scope.$close(this.$scope.checklist);
  };

  private createOkr = () => {
    const newGoal = { id: null };

    this.$scope.$close();
    this.$state.go("gtmhub.home._goalForm.form", newGoal);
  };

  private activateYourSubscription = () => {
    this.$scope.$close();
    this.$state.go("gtmhub.editionPlanChange");
  };

  private skipCompletely = () => {
    this.$scope.checklist.optOut = true;
    this.$scope.$close(this.$scope.checklist);
  };

  private createDemoAccount = () => {
    this.onboardingService.createDemoAccount(this.checklist).then(
      (result) => {
        this.$scope.checklist = result;
        this.$scope.$root.$broadcast("onboarding.createdDemoAccount");
        this.$scope.$close(this.$scope.checklist);
      },
      (error) => {
        this.uiErrorHandlingService.handleModal(error);
      }
    );
  };

  private openInvitationModal = () => {
    this.userInvitationModal.open();
  };
}
